import withActDetail from "../withActDetail";
import ActWasteForm from "./ActWasteForm";
import ActWastePDFGenerator from "./ActWastePDFGenerator";

const actFormKazakhName = 'Шайындыларды іріктеу АКТIСI'
const actFormName = 'АКТ отбора смывов'
const actFormNumber = '003'
const actName = 'ActWaste'

export default withActDetail(ActWasteForm, ActWastePDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)